import { Button, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GENERAL_SPECIALITY_ID } from "../../../envConstants";
import { AUTH_TOKEN, COUNTRY_ID_KEY, INDIAN_COUNTRY_ID } from "../../../utils/constants";
import { getDecodedToken, getLocalStorage, setLocalStorage } from "../../../utils/localStorage";
import { getCountryIdFromMobile } from "../../../utils/helper";
import { getCities, getPediaDoctorDetails, getQualifications, getSpecialities, updatePediaCityQualification, updateSpeciality } from "../service";
import arrowLeft from "./../../../assets/images/arrow-left.svg";
import CitySheet from "./CitySheet";
import ProfileForm from "./ProfileForm";
import QualificationSheet from "./QualificationSheet";
import SpecializationSheet from "./SpecializationSheet";

const YourProfile = () => {
  const navigate = useNavigate();
  const [showSpecializationSheet, setShowSpecializationSheet] = useState(false);
  const [showCitySheet, setShowCitySheet] = useState(false);
  const [showQualificationSheet, setShowQualificationSheet] = useState(false);
  const [specialities, setSpecialities] = useState([]);
  const [cities, setCities]: any = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [selectedQualifications, setSelectedQualifications]: any = useState([]);
  const [qualificationIds, setQualificationIds]: any = useState([]);
  const [selectedSpeciality, setSelectedSpeciality]: any = useState({});
  const [selectedCity, setSelectedCity]: any = useState({});
  const [selectedQualification, setSelectedQualification]: any = useState({});
  const tokenData: any = getDecodedToken();
  const doctorDetails: any = tokenData?.user || {};
  const [pediaDoctor, setPediaDoctor]: any = useState({});
  const [saveLoader, setSaveLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState(pediaDoctor?.email);
  const [isSpecialityEditable, setIsSpecialityEditable] = useState(false);
  const countryId = getLocalStorage(COUNTRY_ID_KEY) || INDIAN_COUNTRY_ID;
  useEffect(() => {
    getDoctorSpecialities();
  }, []);

  useEffect(() => {
    if (pediaDoctor?.email !== null) {
      setEmail(pediaDoctor?.email);
    }
  }, [pediaDoctor]);

  useEffect(()=>{
    if (qualificationIds.length > 0 && qualifications.length > 0) {
      const qualis = qualifications.filter((v: any) => qualificationIds.includes(v.id));
      const uniqueItems = qualis.filter((value: any, index: any, self: any) => {
        return index === self.findIndex((t: any) => t.id === value.id);
      });
      setSelectedQualifications(uniqueItems);
    }
  }, [qualificationIds, qualifications]);


  useEffect(() => {
    if (pediaDoctor?.city_id !== null) {
      setSelectedCity(cities.filter((c: any): any => c.id === pediaDoctor?.city_id)[0]);
    }
  }, [pediaDoctor, cities]);

  useEffect(() => {
    if (pediaDoctor?.qualification_id !== null) {
      setSelectedQualification(qualifications.filter((q: any): any => q.id === pediaDoctor?.qualification_id)[0]);
    }


  }, [pediaDoctor, qualifications]);

  useEffect(() => {
    if (specialities.length > 0 && pediaDoctor && Object.keys(pediaDoctor).length > 0) {
      let specialityId: number | null = null;
      if (pediaDoctor?.speciality?.id) {
        specialityId = pediaDoctor.speciality.id;
      } else if (pediaDoctor?.speciality_id) {
        specialityId = pediaDoctor.speciality_id;
      } else if (pediaDoctor?.id && pediaDoctor?.displayName && pediaDoctor?.code) {
        specialityId = pediaDoctor.id;
      }
      setIsSpecialityEditable(
        !specialityId || specialityId === GENERAL_SPECIALITY_ID
      );
      if (specialityId) {
        const matchedSpeciality: any = specialities.find(
          (s: any) => s?.id === specialityId
        );
        if (matchedSpeciality) {
          setSelectedSpeciality(matchedSpeciality);
        }
      }
    } else if (specialities.length > 0 && !pediaDoctor) {
      const tokenSpecialityId = doctorDetails?.speciality;
      setIsSpecialityEditable(
        !tokenSpecialityId || tokenSpecialityId === GENERAL_SPECIALITY_ID
      );
    }
  }, [pediaDoctor, specialities]);

  const getDoctorSpecialities = async () => {
    setLoader(true);
    const body = await getDoctorDetails();
    getDoctorCities();
    getDoctorQualifications(body?.access_code);
    const res: any = await getSpecialities();
    setLoader(false);
    if (res?.status === 200) {
      setSpecialities(res?.data);
      const tokenSpeciality: any = res?.data?.find(
        (s: any) => s?.id === doctorDetails?.speciality
      );
      setSelectedSpeciality(tokenSpeciality);
    }
  };

  const getDoctorCities = async () => {
    const cid = getLocalStorage(COUNTRY_ID_KEY) || INDIAN_COUNTRY_ID;
    const res: any = await getCities("", cid);
    if (res?.status === 200) setCities(res?.data);
  };
  const getDoctorQualifications = async (accessCode?: string) => {
    const cid = getLocalStorage(COUNTRY_ID_KEY) || INDIAN_COUNTRY_ID;
    const res: any = await getQualifications("", (accessCode ?? pediaDoctor?.access_code) || "", cid);
    if (res?.status === 200) setQualifications(res?.data);
  };
  const getDoctorDetails = async () => {
    if (!doctorDetails?.mobileNumber) return;
    const res: any = await getPediaDoctorDetails(doctorDetails?.mobileNumber);
    if (res?.status === 200 && res?.data?.body) {
      const b = res.data.body;
      setPediaDoctor(b);
      if (b.email !== null && b.email !== undefined) {
        doctorDetails.email = b.email;
      }
      const qIds = b.qualification_ids;
      if (Array.isArray(qIds)) setQualificationIds(qIds);
      const cid = getCountryIdFromMobile(b.mobile_number || doctorDetails?.mobileNumber);
      if (cid != null) setLocalStorage(COUNTRY_ID_KEY, cid);
      return b;
    }
  };

  const updateDoctorSpeciality = async () => {
    if (!selectedSpeciality?.id) {
      notification.error({
        message: 'Please select a speciality',
        description: 'You must select a speciality before saving.',
        duration: 3,
      });
      return;
    }

    if (!doctorDetails?.mobileNumber) {
      notification.error({
        message: 'Error',
        description: 'Mobile number is required.',
        duration: 3,
      });
      return;
    }
    const currentSpecialityId = pediaDoctor?.speciality?.id || 
                                 pediaDoctor?.speciality_id || 
                                 doctorDetails?.speciality;
    if (currentSpecialityId && currentSpecialityId !== GENERAL_SPECIALITY_ID) {
      notification.error({
        message: 'Cannot update speciality',
        description: 'Your speciality has already been set and cannot be changed.',
        duration: 5,
      });
      return;
    }
    setSaveLoader(true);
    try {
      const res: any = await updateSpeciality(doctorDetails?.mobileNumber, {
        speciality: selectedSpeciality.id,
        removeSpecialityId: GENERAL_SPECIALITY_ID,
      });
      setSaveLoader(false);
      if (res?.status === 200) {
        if (res?.data?.token) {
          setLocalStorage(AUTH_TOKEN, res?.data?.token);
        }
        notification.success({
          message: 'Speciality updated successfully',
          duration: 3,
        });
        navigate("/account");
      } else {
        notification.error({
          message: 'Failed to update speciality',
          description: res?.data?.message || 'Please try again later.',
          duration: 5,
        });
      }
    } catch (error: any) {
      setSaveLoader(false);
      notification.error({
        message: 'Error updating speciality',
        description: error?.response?.data?.message || 'An error occurred. Please try again.',
        duration: 5,
      });
    }
  };

  const handleSpeciality = (speciality: any) => {
    setSelectedSpeciality(speciality);
    closeSpecializationSheet();
  };

  const handleCity = (city: any) => {
    setSelectedCity(city);
    closeCitySheet();
  };
  const handleQualification = (q: any) => {
    setSelectedQualification(q);
    const qualis = selectedQualifications;
    qualis.push(q);
    // filter duplicates
    const uniqueItems = qualis.filter((value: any, index: any, self: any) => {
      return index === self.findIndex((t: any) => t.id === value.id);
    });
    setSelectedQualifications(uniqueItems);
    setQualificationIds(uniqueItems.map((v:any)=>v.id));
    // closeQualificationSheet();
  };

  const removeQualification = (id: any) => {
    const qualis = selectedQualifications.filter((item: any) => item.id !== id);
    setSelectedQualifications(qualis);
    setQualificationIds(qualis.map((v:any)=>v.id));
  };

  /**
   * Bulk select/clear for the qualification list.
   *
   * This cannot be done by calling handleQualification in a loop: that handler reads
   * selectedQualifications from its closure and pushes into it, so every call in the same
   * render would start from the same stale array and only the last one would survive.
   * Both pieces of state are set once here instead, exactly as the single-item handlers
   * do, since the save payload is built from qualificationIds.
   *
   * `visible` is the list as currently rendered, so with a search term active this acts
   * on what the user can actually see rather than silently on the whole catalogue.
   */
  const toggleAllQualifications = (visible: any[], selectAll: boolean) => {
    const next = selectAll
      ? [...selectedQualifications, ...visible].filter(
        (value: any, index: number, self: any[]) =>
          index === self.findIndex((t: any) => t.id === value.id)
      )
      : selectedQualifications.filter(
        (item: any) => !visible.some((v: any) => v.id === item.id)
      );

    setSelectedQualifications(next);
    setQualificationIds(next.map((v: any) => v.id));
  };

  const removeQualificationByCode = (code: any) => {
    const qualis = selectedQualifications.filter((item: any) => item.code !== code);
    setSelectedQualifications(qualis);
    setQualificationIds(qualis.map((v:any)=>v.id));
  };

  const openSpecializationSheet = () => {
    setShowSpecializationSheet(true);
  };

  const openCitySheet = () => {
    setShowCitySheet(true);
  };

  const openQualificationSheet = () => {
    setShowQualificationSheet(true);
  };

  const closeCitySheet = () => {
    setShowCitySheet(false);
  };

  const closeQualificationSheet = () => {
    setShowQualificationSheet(false);
  };

  const closeSpecializationSheet = () => {
    setShowSpecializationSheet(false);
  };

  const backBtnHandler = () => {
    navigate("/account");
  };

  const updateCityQualification = async () => {
    if (saveLoader) return;
    setSaveLoader(true);
    try {
      const res: any = await updatePediaCityQualification(
        {
          city_id: selectedCity?.id,
          qualification_id: selectedQualification?.id,
          qualification_ids: qualificationIds,
          email: email,
          mbl_no: doctorDetails?.mobileNumber
        })
      setSaveLoader(false);
      if (res?.status === 200) {
        notification.success({ message: 'Profile updated' });
      } else {
        notification.error({
          message: 'Failed to update profile',
          description: res?.data?.message || 'Please try again later.',
          duration: 5,
        });
      }
    } catch (error: any) {
      setSaveLoader(false);
      notification.error({
        message: 'Error updating profile',
        description: error?.response?.data?.message || 'An error occurred. Please try again.',
        duration: 5,
      });
    }
  };

  const handleQualificationUpdate = (e: any[]) => {
    setQualificationIds(e);
  };

  return (
    <>
      <div className="border-b border-[#EAECF0] sticky top-0 bg-white z-[10]">
        <div className="flex items-start font-semibold gap-x-2 p-6">
          <img
            height={22}
            width={22}
            src={arrowLeft}
            alt="arrow-left"
            onClick={backBtnHandler}
          />
          <span>Your Profile</span>
        </div>
      </div>
      {loader ? (
        <Spin className="mt-4 flex justify-center items-center" />
      ) : (
        <div className="flex flex-col w-full bg-white">
          <div className="pb-16">
            <ProfileForm
              openSpecializationSheet={openSpecializationSheet}
              openCitySheet={openCitySheet}
              openQualificationSheet={openQualificationSheet}
              selectedSpeciality={selectedSpeciality}
              selectedCity={selectedCity}
              selectedQualification={selectedQualification}
              doctorDetails={doctorDetails}
              isSpecialityEditable={isSpecialityEditable}
              setEmail={setEmail}
              cities={cities}
              email={email}
              handleCityUpdate={handleCity}
              handleQualificationUpdate={handleQualificationUpdate}
              qualifications={qualifications}
              qualificationIds={qualificationIds}
              removeQualification={removeQualification}
              selectedQualifications={selectedQualifications}
              removeQualificationByCode={removeQualificationByCode}
            />
          </div>
          {isSpecialityEditable ? (
            <div className="flex flex-col justify-center items-center px-6 py-4 sticky bottom-0 w-full text-lg font-medium leading-none text-center whitespace-nowrap border-t border-solid border-t-zinc-200 bg-white z-10">
              <Button
                className={`overflow-hidden gap-2 self-stretch p-8 rounded-2xl text-lg ${selectedSpeciality?.id
                  ? "bg-[#4B4AD5] text-white"
                  : "bg-zinc-100 text-slate-400"
                  }`}
                disabled={!selectedSpeciality?.id}
                onClick={updateDoctorSpeciality}
                loading={saveLoader}
              >
                Save
              </Button>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center w-full px-6 py-4 sticky bottom-0 border-t border-solid border-t-zinc-200 bg-white z-10">
              <Button
                className={`overflow-hidden gap-2 self-stretch p-8 rounded-2xl text-lg bg-[#4B4AD5] text-white`}
                onClick={() => updateCityQualification()}
                loading={saveLoader}
                disabled={!(selectedCity?.id && selectedQualifications?.length > 0)}
              >
                Save
              </Button>
            </div>
          )}

          <SpecializationSheet
            show={showSpecializationSheet}
            closePopup={closeSpecializationSheet}
            specialities={specialities}
            handleSpeciality={handleSpeciality}
          />
          <CitySheet
            show={showCitySheet}
            cities={cities}
            closePopup={closeCitySheet}
            handleCity={handleCity}
          />
          <QualificationSheet
            show={showQualificationSheet}
            qualifications={qualifications}
            closePopup={closeQualificationSheet}
            handleQualification={handleQualification}
            selectedQualifications={selectedQualifications}
            removeQualificationByCode={removeQualificationByCode}
            toggleAllQualifications={toggleAllQualifications}
          />
        </div>
      )}
    </>
  );
};

export default YourProfile;
